import React from 'react';
import InvestigationDetailTooltip from './InvestigationDetailTooltip';
import style from './index.scss';

const chunkArray = (array, chunk_size) => {
  let index = 0;
  let arrayLength = array.length;
  let tempArray = [];

  for (index = 0; index < arrayLength; index += chunk_size) {
    let currentChunk = array.slice(index, index + chunk_size);
    tempArray.push(currentChunk);
  }

  return tempArray;
};

const CustomerProfileItem = ({ alertDetail, item }) => {
  const { key, label } = item;

  let alertDetailValue = '';
  if (
    alertDetail[key] &&
    alertDetail[key] !== '' &&
    String(alertDetail[key]).toUpperCase().trim() !== 'NULL'
  ) {
    alertDetailValue = alertDetail[key];
  } else if (label) {
    alertDetailValue = '-';
  }

  let toolTip = null;
  if (String(alertDetailValue).length > 13) {
    toolTip = (
      <InvestigationDetailTooltip
        placement="bottom"
        target={`customer-profile-item-${key}`}>
        <div className={style.toolTipItem}>{alertDetailValue}</div>
      </InvestigationDetailTooltip>
    );
  }

  return (
    <div className="row">
      <div className="col-sm-6">
        <p style={{ color: '#eef4fa' }}>{label ? `${label}:  ` : null}</p>
      </div>

      <div className="col-sm-6">
        <b
          style={{
            cursor: String(alertDetailValue).length > 13 ? 'pointer' : null
          }}
          id={`customer-profile-item-${key}`}>
          {String(alertDetailValue).length > 13
            ? `${String(alertDetailValue).substring(0, 13)}...`
            : String(alertDetailValue)}
        </b>
        {toolTip}
      </div>
    </div>
  );
};

const CustomerProfilePanel = ({ alertDetail, customerProfileMetadata }) => {
  if (alertDetail) {
    // chunk the metadata into different columns
    const chunkedProfileMetaData = chunkArray(customerProfileMetadata, 3);
    const customerProfileItems = chunkedProfileMetaData.map(
      (currentMetadataChunk) => {
        const currentChunkItems = currentMetadataChunk.map(
          (customerProfileMetaItem) => {
            return (
              <CustomerProfileItem
                item={customerProfileMetaItem}
                alertDetail={alertDetail}
              />
            );
          }
        );

        return <div className="col-sm-3">{currentChunkItems}</div>;
      }
    );

    return (
      <div className={style.customerProfilePanel}>
        <div className="row">{customerProfileItems}</div>
      </div>
    );
  }

  return null;
};

export default CustomerProfilePanel;
